import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '@/lib/auth'
import { useI18n } from '@/lib/i18n'
import { returnTargetFrom, verifyEmailUrlReturningTo } from '@/lib/return-target'

export function GameEmailVerificationGuard({ children }: { children: ReactNode }) {
  const { user, authResolved } = useAuth()
  const location = useLocation()
  const { t } = useI18n()

  if (!authResolved) {
    return (
      <main className="min-h-screen px-4 pt-28" role="status">
        {t('forum.loading')}
      </main>
    )
  }

  if (user && !user.gameIdentityVerified) {
    return (
      <Navigate
        to={verifyEmailUrlReturningTo(returnTargetFrom(location))}
        replace
      />
    )
  }

  return children
}
